module.exports = __webpack_public_path__ + "img/e-14.63329dd6.jpg";